<template>
  <v-main>
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <v-container fluid>
      <v-card>
        <v-card-title> Setting Telemedicine </v-card-title>
        <v-fab-transition>
          <v-btn
            v-if="isEditable == 0"
            class="mt-8 mr-4"
            color="pink"
            dark
            absolute
            top
            right
            fab
            @click="changeEditable"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="pl-4 pr-4 pt-4"
        >
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="dataRs.durasi_konsultasi"
                    label="Durasi Konsultasi (Menit)"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                    type="Number"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="dataRs.jam_paling_lambat_konsultasi"
                    label="Konsultasi paling lambat (Jam)"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                    type="Number"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="dataRs.nama_apoteker"
                    label="Nama Apoteker"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="dataRs.no_telepon_apoteker"
                    label="No Telepon Apoteker"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="dataRs.api_key"
                    label="Watzap Api Key"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="dataRs.number_key"
                    label="Watzap Number Key"
                    outlined
                    dense
                    :readonly="isEditable == 0"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                v-if="isEditable == 1"
                style="margin-right: 10px"
                @click="doBatal"
                >Batal</v-btn
              >
              <v-btn
                v-if="isEditable == 1"
                dark
                color="primary"
                type="button"
                @click="doSubmit"
                >Simpan</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import SettingTelemedicineService from "../services/SettingTelemedicineService";
import CommonService from "../services/CommonService";

export default {
  name: "SettingTelemedicine",
  components: {},
  data: () => ({
    isEditable: 0,
    breadcrumbs: [{ text: "Setting Telemedicine", disabled: true }],
    valid: true,
    dataRs: {
      durasi_konsultasi: "",
      nama_apoteker: "",
      no_telepon_apoteker: "",
      jam_paling_lambat_konsultasi: "",
    },
  }),
  mounted: async function () {
    this.getDataRumahSakit();
  },
  methods: {
    changeEditable: function () {
      this.isEditable = 1;
    },

    async getDataRumahSakit() {
      SettingTelemedicineService.getSetting()
        .then((res) => {
          this.dataRs = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    doBatal: function () {
      this.isEditable = 0;
      this.getDataRumahSakit();
    },

    doSubmit: async function () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0);
        return;
      }

      SettingTelemedicineService.update(1, this.dataRs)
        .then(() => {
          this.isEditable = 0;
          CommonService.showSuccessToast(
            "Update Setting telemedicine berhasil",
          );

          this.getDataRumahSakit();
        })
        .catch((err) => {
          console.log(err);
          CommonService.showErrorToast(
            "Update Setting telemedicine gagal. Coba lagi",
          );
        });
    },
  },
};
</script>

<style scoped></style>
